module.exports = __webpack_public_path__ + "static/media/no-results.7dd7842e.PNG";